<div class="row">
  <div class="col">
    <a [href]="documentPath" target="blank">{{ documentName }}</a>
  </div>
</div>
